module.exports = __webpack_public_path__ + "img/header-weddingRingsHearts.3322158.webp";